export const dataModels = {
	GENERIC_PROCESS_MODEL: "Generic_Prozess_WF"
};
export const overviewModels = {
	LINKED_PROCESSES_O: "Linked_Processes_O"
};
